import base from '../JsonLang/de.json'
import act from '../JsonAct/de.json'

function deepMerge(target, source) {
  const out = { ...target }
  for (const key of Object.keys(source)) {
    const sv = source[key]
    const tv = target[key]
    if (sv && typeof sv === 'object' && !Array.isArray(sv) && tv && typeof tv === 'object' && !Array.isArray(tv)) {
      out[key] = deepMerge(tv, sv)
    } else {
      out[key] = sv
    }
  }
  return out
}

export const lang = deepMerge({ ...base }, act)
